export default __webpack_public_path__ + "2b0423d85f0fba68c924035ffb25e139.png";